<template>

    <div class="tw-m-5">

        <div class="tw-mb-1 tw-text-gray-600 label">{{ label }}</div>

        <small v-if="instruction"
               class="tw-block tw-mb-3 tw-text-gray-500 label tw-text-muted">{{ instruction }}</small>

        <div class="mt-1">

            <button v-for="color in colors"
                    :style="{ background: color !== 'transparent' ? color : '' }"
                    class="tw-w-8 tw-h-8 tw-inline-block tw-mr-1 tw-cursor-pointer tw-shadow-sm tw-border focus:tw-outline-none focus:tw-ring-blue-600 focus:tw-border-blue-600 sm:tw-text-sm tw-border-gray-300 tw-rounded-md"
                    :class="{ selected: color === currentColor, checkered: color === 'transparent'  }"
                    @click="setValue(color)"/>

        </div>

    </div>

</template>

<script>

export default {

    props: {

        label: {
            type: String,
            required: true,
        },
        instruction: String,

        options: {
            type: Object,
            required: true,
        },
        optionsProperty: {
            required: true,
        },

        colors: {
            type: Array,
            required: true,
        },

        defaultColor: {},
    },

    methods: {

        setValue(value) {
            // Set in options.
            this.$set(this.options, this.optionsProperty, value);

            // Emit for whoever wants to know.
            this.$emit('colorChange');
        }

    },

    computed: {

        currentColor() {
            // Get value from options.
            let value = this.options[this.optionsProperty];

            // Use value of default value?
            return value === undefined ? this.defaultColor : value;
        },

    },

}

</script>

<style lang="scss" scoped>

.selected {
    @apply tw-shadow-sm tw-ring-blue-600 tw-border-blue-600;
}

.checkered {
    background:                linear-gradient(45deg, rgba(0, 0, 0, 0.0980392) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.0980392) 75%, rgba(0, 0, 0, 0.0980392) 0), linear-gradient(45deg, rgba(0, 0, 0, 0.0980392) 25%, transparent 25%, transparent 75%, rgba(0, 0, 0, 0.0980392) 75%, rgba(0, 0, 0, 0.0980392) 0), white;
    background-repeat:         repeat, repeat;
    background-position:       0 0, 5px 5px;
    -webkit-transform-origin:  0 0 0;
    transform-origin:          0 0 0;
    -webkit-background-origin: padding-box, padding-box;
    background-origin:         padding-box, padding-box;
    -webkit-background-clip:   border-box, border-box;
    background-clip:           border-box, border-box;
    -webkit-background-size:   10px 10px, 10px 10px;
    background-size:           10px 10px, 10px 10px;
    -webkit-transform:         scaleX(1) scaleY(1) scaleZ(1);
    transform:                 scaleX(1) scaleY(1) scaleZ(1);
}

</style>
